import * as React from 'react';
import { styled } from '@mui/material/styles';

import { ELineIconName } from './enum';

const StyledIcon = styled('i')<{ name: ELineIconName | string; fontSize: number }>(({ name, fontSize }) => ({
    fontFamily: 'SimpleLineIcon',
    '&::after': {
        content: `"\\${name}"`,
        fontSize: `${fontSize}px`
    }
}));

interface IProps {
    name: ELineIconName | string;
    fontSize: number;
}

export const LineIcon: React.FC<IProps> = ({ name, fontSize }) => (
    <StyledIcon name={name} fontSize={fontSize} />
);
